import axios from 'axios'

const token = typeof window !== "undefined" && window.localStorage.getItem('token')
export const ApiClient = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL
})